import { useAlertSetting } from "./useAlertSettings";

/** Settings > Dashboard home > Show confidence score information (org-wide, off by default). Shares the settings query's cache. */
export function useShowConfidenceInfo(): boolean {
  return useAlertSetting("show_confidence_info") === true;
}
